<template>
  <form @submit.prevent="onSubmit" class="form">
    <input
      type="text"
      class="form__input"
      v-model="name"
      :placeholder="placeholder"
    />
    <button
      type="submit"
      :disabled="!isSubmitButtonEnabled"
      class="form__submit"
    >
      作成
    </button>
  </form>
</template>

<script>
import { restClient } from '../../../libs/restClient';

export default {
  name: 'TagCreateForm',
  props: {
    tagType: {
      type: String,
      required: true,
    },
    parentId: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: '',
    };
  },
  computed: {
    isSubmitButtonEnabled() {
      return this.name !== '';
    },
  },
  methods: {
    async onSubmit() {
      try {
        this.$root.$refs.loadModal.loading = true;
        const { data } = await restClient.post('/api/tags/', {
          name: this.name,
          tag_type: this.tagType,
          parent_id: this.tagType === 'tag' ? null : this.parentId,
        });
        this.$emit('createTag', data);
        this.name = '';
        this.$root.$refs.loadModal.success = true;
      } catch (error) {
        console.error(error);
        this.$root.$refs.loadModal.error = true;
      } finally {
        setTimeout(() => {
          this.$root.$refs.loadModal.loading = false;
          this.$root.$refs.loadModal.success = false;
          this.$root.$refs.loadModal.error = false;
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin action {
  display: flex;
  align-items: center;
  border: 0;
  border-radius: 4px;
  padding: 0.4em 0.6em 0.3em;
  color: #fff;
  font-size: 18px;
  line-height: 1;

  &:hover {
    cursor: pointer;
  }

  &[disabled] {
    background-color: #eee;
    cursor: not-allowed;
  }

  span {
    font-size: 12px;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}

.form {
  display: flex;
  align-items: center;

  &__input {
    padding: 6px 8px;
    font-size: 12px;
    width: 260px;
  }

  &__submit {
    @include action;

    flex: 0 0 auto;
    background-color: #48c78e;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}
</style>
